import { useSearchParams } from 'next/navigation';
import { MdClose } from 'react-icons/md';
import { allowedFilterParams } from '@api/allowedParams';
import QueryLink from '@components/QueryLink';
import { useTranslations } from 'next-intl';
import { useGetLocalizedName } from '@/src/utils/internationalization/getLocalizedName';
import { useGetCategoryById } from '@/src/utils/categories/useGetCategoryById';

export default function ActiveFilters() {
  const a = useTranslations('ActiveFilters');
  const t = useTranslations('Filter');
  const getCategoryById = useGetCategoryById();
  const getLocalizedName = useGetLocalizedName();
  const searchParams = useSearchParams();
  const labelsMap = {
    year_le: `${t('year.label')} <`,
    year_ge: `${t('year.label')} >`,
    price_le: `${t('price.label')} <`,
    price_ge: `${t('price.label')} >`,
    meta_hours_le: `${t('hours.label')} <`,
    meta_hours_ge: `${t('hours.label')} >`,
    meta_km_le: `${t('mileage.label')} <`,
    meta_km_ge: `${t('mileage.label')} >`,
    meta_hk_le: `${t('horsepower.label')} <`,
    meta_hk_ge: `${t('horsepower.label')} >`,
    meta_kg_le: `${t('weight.label')} <`,
    meta_kg_ge: `${t('weight.label')} >`,
    category_id: '',
    make: '',
    is_auction: `${t('typesOfSale.label')}`,
    search: `${a('search')}:`,
    zipcode: `${t('area.zip')}:`,
    municipality: `${t('area.municipality')}:`,
  };

  const getFilters = () => {
    let filters = [] as any[];
    allowedFilterParams.map((param) => {
      if (!searchParams.get(param)) return null;
      const query = new URLSearchParams(Array.from(searchParams.entries()));
      query.delete(param);
      query.delete('page');
      let valueLabel = searchParams.get(param);
      let paramLabel = labelsMap[param as keyof typeof labelsMap];
      if (param === 'search') {
        query.delete('lang');
      }
      if (param === 'is_auction') {
        valueLabel = valueLabel === '1' ? a('auction') : a('fixed');
        paramLabel = '';
      }
      if (
        [
          'municipality',
          'category_id',
          'county',
          'country',
          'group_id',
        ].includes(param)
      ) {
        paramLabel = '';
      }
      if (param === 'category_id') {
        valueLabel = String(searchParams.get(param))
          .split(',')
          .map((cat: string) => {
            cat = getCategoryById(parseInt(cat));
            return getLocalizedName(cat);
          })
          .join(', ');
      } else if (param === 'make') {
        valueLabel = String(searchParams.get(param)).split(',').join(', ');
        query.delete('model');
      } else if (param === 'county' || param === 'country') {
        if (param === 'country' && searchParams.get('county')) {
          return;
        }
        valueLabel = String(searchParams.get(param))
          .split(',')
          .map((region) => {
            return region[0].toUpperCase() + region.slice(1);
          })
          .join(', ');
      }
      filters.push({
        paramLabel,
        valueLabel,
        queryString: query.toString(),
      });
    });
    return filters;
  };

  return (
    <div className='flex flex-wrap items-center gap-2'>
      <span className='text-lg font-bold uppercase'>{a('label')}</span>
      {getFilters().map(
        ({
          paramLabel,
          valueLabel,
          queryString,
        }: {
          paramLabel: string;
          valueLabel: string;
          queryString: string;
        }) => {
          return (
            <QueryLink
              key={queryString}
              query={queryString}
              className='m-2 flex items-center gap-2 rounded border border-white py-1 pl-4 pr-2 text-white hover:bg-white hover:text-dark'
            >
              {paramLabel} <span className='font-bold'>{valueLabel}</span>
              <span className='text-xl'>
                <MdClose />
              </span>
            </QueryLink>
          );
        }
      )}
    </div>
  );
}
